export var PlanAndBillingState;
(function (PlanAndBillingState) {
    PlanAndBillingState["PlanAndBilling"] = "dashboard.settings.plan-and-billing";
    PlanAndBillingState["Plan"] = "dashboard.settings.plan-and-billing.plan";
    PlanAndBillingState["Billing"] = "dashboard.settings.plan-and-billing.billing";
    PlanAndBillingState["Usage"] = "dashboard.settings.plan-and-billing.usage";
    PlanAndBillingState["AiSettings"] = "dashboard.settings.plan-and-billing.ai-settings";
})(PlanAndBillingState || (PlanAndBillingState = {}));
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["Monthly"] = "MONTHLY";
    BillingCycle["Quarterly"] = "QUARTERLY";
    BillingCycle["Annually"] = "ANNUALLY";
})(BillingCycle || (BillingCycle = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CreditCard"] = "CREDIT_CARD";
    PaymentMethod["WireTransfer"] = "WIRE_TRANSFER";
    PaymentMethod["MarketPlaceAWS"] = "MARKET_PLACE_AWS";
    PaymentMethod["MarketPlaceAZURE"] = "MARKET_PLACE_AZURE";
    PaymentMethod["Other"] = "OTHER";
})(PaymentMethod || (PaymentMethod = {}));
export var ProductType;
(function (ProductType) {
    ProductType["GbRetention"] = "GB_RETENTION";
    ProductType["UniqueMetrics"] = "UM";
    ProductType["SpansM"] = "SPANS";
    ProductType["Gb"] = "GB";
    ProductType["OnDemand"] = "ON_DEMAND";
})(ProductType || (ProductType = {}));
export var PurchaseFlowStage;
(function (PurchaseFlowStage) {
    PurchaseFlowStage[PurchaseFlowStage["ConfigurePlan"] = 0] = "ConfigurePlan";
    PurchaseFlowStage[PurchaseFlowStage["PaymentDetails"] = 1] = "PaymentDetails";
    PurchaseFlowStage[PurchaseFlowStage["UpgradeSummary"] = 2] = "UpgradeSummary";
})(PurchaseFlowStage || (PurchaseFlowStage = {}));
export var PlanAndBillingSubject;
(function (PlanAndBillingSubject) {
    PlanAndBillingSubject["PlanPage"] = "plan-page";
    PlanAndBillingSubject["UsagePage"] = "usage-page";
    PlanAndBillingSubject["Promotions"] = "promotions";
    PlanAndBillingSubject["VolumeAnalysis"] = "volume-analysis";
    PlanAndBillingSubject["PlanSummary"] = "plan-summary";
    PlanAndBillingSubject["ProductBrand"] = "product-brand";
    PlanAndBillingSubject["ActiveProduct"] = "active-product";
    PlanAndBillingSubject["InactiveProduct"] = "inactive-product";
    PlanAndBillingSubject["OwnedProduct"] = "owned-product";
    PlanAndBillingSubject["OwnedProductParam"] = "owned-product-param-";
    PlanAndBillingSubject["PlanConfigurationPrice"] = "plan-configuration-price";
    PlanAndBillingSubject["PlanConfigurationAddProduct"] = "plan-configuration-add-product-";
    PlanAndBillingSubject["PlanConfigurationConfigureProduct"] = "plan-configuration-configure-product";
    PlanAndBillingSubject["ProductConfiguration"] = "product-configuration";
    PlanAndBillingSubject["PlanSelection"] = "plan-selection";
    PlanAndBillingSubject["ParamSelect"] = "param-select";
    PlanAndBillingSubject["CompanyDetailsFormSection"] = "company-details-form-section";
    PlanAndBillingSubject["BillingAddressFormSection"] = "billing-address-form-section";
    PlanAndBillingSubject["ShippingAddressFormSection"] = "shipping-address-form-section";
    PlanAndBillingSubject["CreditCardFormSection"] = "credit-card-form-section";
    PlanAndBillingSubject["ShoppingCartSubmit"] = "shopping-cart-submit";
    PlanAndBillingSubject["PurchaseFlowModal"] = "purchase-flow-modal";
    PlanAndBillingSubject["ShoppingCartTax"] = "shopping-cart-tax";
    PlanAndBillingSubject["GeneralErrorModal"] = "general-error-modal";
    PlanAndBillingSubject["UpgradeErrorModal"] = "upgrade-error-modal";
    PlanAndBillingSubject["PageGeneralErrorModal"] = "page-general-error-modal";
    PlanAndBillingSubject["PaymentStripeError"] = "payment-stripe-error";
    PlanAndBillingSubject["ShoppingCartDisclaimer"] = "shopping-cart-disclaimer";
    PlanAndBillingSubject["ProceedToCheckoutConfirmation"] = "proceed-to-checkout-confirmation";
    PlanAndBillingSubject["SubmitPayment"] = "submit-payment";
    PlanAndBillingSubject["ShoppingCartRow"] = "shopping-cart-row";
    PlanAndBillingSubject["ShoppingCart"] = "shopping-cart";
    PlanAndBillingSubject["GoBack"] = "go-back";
    PlanAndBillingSubject["StartVolumeAnalysis"] = "start-volume-analysis";
    PlanAndBillingSubject["PaymentStage"] = "payment-stage";
    PlanAndBillingSubject["Tax"] = "tax";
    PlanAndBillingSubject["UpgradeStage"] = "upgrade-stage";
    PlanAndBillingSubject["SuccessModal"] = "success-modal";
    PlanAndBillingSubject["SuccessModalSubmit"] = "success-modal-submit";
    PlanAndBillingSubject["SuccessModalTitle"] = "success-modal-title";
    PlanAndBillingSubject["BillingCycle"] = "billing-cycle";
    PlanAndBillingSubject["ShippingAddressCheckbox"] = "shipping-address-checkbox";
    PlanAndBillingSubject["LogManagementUsageGraph"] = "log-management-usage-graph";
    PlanAndBillingSubject["InfrastructureMonitoringUsageGraph"] = "infrastructure-monitoring-usage-graph";
    PlanAndBillingSubject["UsageStatusLine"] = "usage-status-line";
    PlanAndBillingSubject["ProductPlanNote"] = "product-plan-note";
    PlanAndBillingSubject["MonthlyUsageGraph"] = "monthly-usage-graph";
    PlanAndBillingSubject["ExpandUsageData"] = "expand-usage-data";
    PlanAndBillingSubject["AiSettingsPage"] = "ai-settings-page";
    PlanAndBillingSubject["AiSettingsOrionIqCta"] = "ai-settings-orioniq-cta";
})(PlanAndBillingSubject || (PlanAndBillingSubject = {}));
export var CreditCardStatus;
(function (CreditCardStatus) {
    CreditCardStatus[CreditCardStatus["Disabled"] = 0] = "Disabled";
    CreditCardStatus[CreditCardStatus["Enabled"] = 1] = "Enabled";
    CreditCardStatus[CreditCardStatus["Valid"] = 2] = "Valid";
    CreditCardStatus[CreditCardStatus["Error"] = 3] = "Error";
    CreditCardStatus[CreditCardStatus["InProgress"] = 4] = "InProgress";
})(CreditCardStatus || (CreditCardStatus = {}));
export var AddressType;
(function (AddressType) {
    AddressType["Billing"] = "billingAddress";
    AddressType["Shipping"] = "shippingAddress";
})(AddressType || (AddressType = {}));
export var PurchaseFlow;
(function (PurchaseFlow) {
    PurchaseFlow["Custom"] = "custom";
    PurchaseFlow["SemiAuto"] = "semiAuto";
    PurchaseFlow["Auto"] = "auto";
    PurchaseFlow["Downgrade"] = "downgrade";
})(PurchaseFlow || (PurchaseFlow = {}));
export var ProductParamsChange;
(function (ProductParamsChange) {
    ProductParamsChange[ProductParamsChange["None"] = 0] = "None";
    ProductParamsChange[ProductParamsChange["Upgrade"] = 1] = "Upgrade";
    ProductParamsChange[ProductParamsChange["Downgrade"] = 2] = "Downgrade";
})(ProductParamsChange || (ProductParamsChange = {}));
export var UsageResponseStatus;
(function (UsageResponseStatus) {
    UsageResponseStatus["Success"] = "SUCCESS";
    UsageResponseStatus["TimeOut"] = "TIME_OUT";
    UsageResponseStatus["GeneralError"] = "GENERAL_ERROR";
})(UsageResponseStatus || (UsageResponseStatus = {}));
export var UsageStatus;
(function (UsageStatus) {
    UsageStatus["OverTheLimit"] = "OverTheLimit";
    UsageStatus["NearTheLimit"] = "NearTheLimit";
    UsageStatus["Ok"] = "Ok";
})(UsageStatus || (UsageStatus = {}));
export var ProductUsageType;
(function (ProductUsageType) {
    ProductUsageType[ProductUsageType["MonthlyTotalUsage"] = 0] = "MonthlyTotalUsage";
    ProductUsageType[ProductUsageType["MonthlyOverageDaysCount"] = 1] = "MonthlyOverageDaysCount";
})(ProductUsageType || (ProductUsageType = {}));
export var PlanChangeConfirmation;
(function (PlanChangeConfirmation) {
    PlanChangeConfirmation[PlanChangeConfirmation["TrialAccountMigration"] = 0] = "TrialAccountMigration";
    PlanChangeConfirmation[PlanChangeConfirmation["FinalizeBySupport"] = 1] = "FinalizeBySupport";
    PlanChangeConfirmation[PlanChangeConfirmation["Downgrade"] = 2] = "Downgrade";
})(PlanChangeConfirmation || (PlanChangeConfirmation = {}));
export var ProductPlanResponseStatus;
(function (ProductPlanResponseStatus) {
    ProductPlanResponseStatus["SUCCESS"] = "SUCCESS";
    ProductPlanResponseStatus["TIME_OUT"] = "TIME_OUT";
    ProductPlanResponseStatus["GENERAL_ERROR"] = "GENERAL_ERROR";
})(ProductPlanResponseStatus || (ProductPlanResponseStatus = {}));
export var LogMeasurementType;
(function (LogMeasurementType) {
    LogMeasurementType["Indexed"] = "INDEXED";
    LogMeasurementType["Ingested"] = "INGESTED";
})(LogMeasurementType || (LogMeasurementType = {}));
export var StripeRegion;
(function (StripeRegion) {
    StripeRegion["US"] = "US";
    StripeRegion["NonUS"] = "NON_US";
})(StripeRegion || (StripeRegion = {}));
export var OnDemandUsageType;
(function (OnDemandUsageType) {
    OnDemandUsageType["USAGE"] = "USAGE";
    OnDemandUsageType["OVERAGE"] = "OVERAGE";
    OnDemandUsageType["DROP_LOGS"] = "DROP_LOGS";
    OnDemandUsageType["API_CALLS"] = "API_CALLS";
})(OnDemandUsageType || (OnDemandUsageType = {}));
export var PromotionType;
(function (PromotionType) {
    PromotionType["CONSUMPTION_BASED_BILLING_PROMOTION"] = "CONSUMPTION_BASED_BILLING_PROMOTION";
})(PromotionType || (PromotionType = {}));
export const CANCELLATION_NOTICE_DAYS = 30;
//# sourceMappingURL=plan-and-billing.enum.js.map